"use client";

import * as api from "@/lib/auth-api";
import { EmailFormValues, pageHref } from "@/lib/auth-flow";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "sonner";
import { SubmitButton } from "./auth-ui";
import { EmailField } from "./email-field";

export function ForgotForm({ redirect }: { redirect: string }) {
  const router = useRouter();
  const form = useForm<EmailFormValues>({
    defaultValues: { email: "" },
  });

  const mutation = useMutation(
    async (v: EmailFormValues) => {
      const email = v.email.trim();
      await api.requestReset(email);
      return email;
    },
    {
      onSuccess: (email) =>
        router.push(pageHref("/verify", email, { purpose: "reset", redirect: redirect === "/" ? undefined : redirect })),
      onError: (e) => toast.error(api.getErrorMessage(e)),
    },
  );

  return (
    <FormProvider {...form}>
      <form noValidate onSubmit={form.handleSubmit((v) => mutation.mutate(v))} className="grid gap-4">
        <EmailField serverErrors={api.getServerErrors(mutation.error)} />
        <div className="pt-2">
          <SubmitButton loading={mutation.isLoading || mutation.isSuccess}>Kirim</SubmitButton>
        </div>
      </form>
    </FormProvider>
  );
}
